export const InstagramLink = 'https://www.instagram.com/aviagames_/'
export const LinkedinLink = 'https://www.linkedin.com/company/aviagames'
export const FacebookLink = 'https://www.facebook.com/AviaGames'
